import { ENVIRONMENT } from '../constants';

export const isLocalEnv = (): boolean => ENVIRONMENT.appEnv === 'local';

export const isProductionEnv = (): boolean =>
  ENVIRONMENT.appEnv === 'production';
